import { theme } from '../../../../../core/theme/theme';

export const LoadingOverlayStyles = {
    Overlay: {
        position: 'absolute',
        display:'flex',
        flexDirection: 'column',
        justifyContent:'center',
        top: 0,
        width: '100%',
        height: '100vh',
        overflow: 'hidden',
        zIndex: 2000,
        backgroundColor: theme.colors.default,
    },
} as const;

export const RegionLoadingOverlayStyles = {
    Overlay: {
        position: 'absolute',
        display:'flex',
        flexDirection: 'column',
        justifyContent:'center',
        top: 0,
        width: '100%',
        height: '100vh',
        overflow: 'hidden',
        zIndex: 2000,
        backgroundColor: theme.colors.default,
        opacity:.5
    },
} as const;